import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    height: 192,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    border: '1px solid #EFEFEF',
    [theme.breakpoints.up('md')]: {
      height: 192
    }
  },
  icon: {
    width: 48,
    height: 48,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
      width: 80,
      height: 80,
      marginBottom: theme.spacing(3)
    }
  },
  caption: {
    textAlign: 'center',
    maxWidth: 300,
    color: theme.palette.common.black,
    fontSize: 16,
    lineHeight: 1.18,
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
      maxWidth: 380,
      fontSize: 18,
      lineHeight: 1.18
    },
  },
}));
